import React from 'react';
import FlexionChart from './FlexionChart';

export default function LegAngleChart({ timeSeriesData, height = "400px" }) {
  if (!timeSeriesData || timeSeriesData.length === 0) {
    return null; // Don't render anything if no data
  }

  return (
    <FlexionChart
      title="Leg Angle Analysis (Normalized)"
      timeSeriesData={timeSeriesData}
      leftDataKey="left_leg_angle_norm"
      rightDataKey="right_leg_angle_norm"
      height={height}
      yAxisLabel="Leg Angle (degrees)"
      leftColor="#9C27B0"
      rightColor="#FF5722"
    />
  );
}
